<template>
  <div class="row bg-light border border-secondary rounded mb-3">
    <div class="col-12">
      <div
        class="event-summary-toggle pt-2"
        role="button"
        :aria-expanded="expanded ? 'true' : 'false'"
        @click="toggleDetail"
      >
        <div class="row mb-1">
            <div class="col-md-12 d-flex align-items-center">
                <font-awesome-icon icon="fa-chevron-right" class="event-toggle-icon me-2" />
                <h4 class="title03 page__h3 mb-0" v-html="data.mfj_event_sub_data_event_name"></h4>
            </div>
        </div>
        <div class="row event-summary-meta">
            <div class="col-sm-2 col-4 bg_org_gray p-1 text-center">
                <font-awesome-icon icon="fa-calendar-alt" class="me-2" />開催期間
            </div>
            <div class="col-sm-4 col-8 p-1">
                {{data.event_start}}〜{{data.event_end}}
            </div>
            <div class="col-sm-2 col-4 bg_org_gray p-1 text-center">
                <font-awesome-icon icon="fa-map-marker-alt" class="me-2" />開催場所
            </div>
            <div class="col-sm-4 col-8 p-1" v-html="data.hall_name">
            </div>
        </div>
      </div>

      <div v-show="expanded" class="info-grid">
        <div class="info-item" v-if="data.entry_start != '0000-00-00' && data.entry_end != '0000-00-00'">
            <div class="info-label bg_org_gray">エントリー期間</div>
            <div class="info-value">{{data.entry_start}} 〜 {{data.entry_end}}</div>
        </div>
        <div class="info-item" v-if="data.mfj_event_main_data_url">
            <div class="info-label bg_org_gray">案内ページ</div>
            <div class="info-value">
                <a :href="data.mfj_event_main_data_url" target="_blank">
                    <i class="fas fa-external-link-alt"></i> 詳細はこちら
                </a>
            </div>
        </div>
        <div class="info-item" v-if="data.race_owner_name">
            <div class="info-label bg_org_gray">主催者名</div>
            <div class="info-value" v-html="data.race_owner_name"></div>
        </div>
        <div class="info-item">
            <div class="info-label bg_org_gray">連絡先</div>
            <div class="info-value">
                <p class="mb-1">
                    <span class="badge bg-secondary me-2">連絡先名称</span>
                    <span v-if="data.race_owner_access_name" v-html="data.race_owner_access_name"></span>
                    <span v-else v-html="data.race_owner_name"></span>
                </p>
                <p class="mb-1">
                    <span class="badge bg-secondary me-2">連絡先TEL</span>
                    <span v-if="data.race_owner_access_tel" v-html="data.race_owner_access_tel"></span>
                    <span v-else v-html="data.race_owner_tel"></span>
                </p>
                <p class="mb-1" v-if="data.race_owner_access_cellphone">
                    <span class="badge bg-secondary me-2">連絡先携帯</span>
                    <span v-html="data.race_owner_access_cellphone"></span>
                </p>
            </div>
        </div>
        <div class="info-item" v-if="data.mfj_event_sub_data_entry_price">
            <div class="info-label bg_org_gray">エントリー料金</div>
            <div class="info-value" v-html="data.mfj_event_sub_data_entry_price"></div>
        </div>
        <div class="info-item" v-if="Object.keys(data.classes).length > 0">
            <div class="info-label bg_org_gray">
                承認クラス
            </div>
            <div class="info-value">
                <div class="pb-1 mb-1 border-bottom border-dotted" v-for="class_name in data.classes" :key="class_name">
                  <span v-html="class_name"></span>
                </div>

                <div class="info-label-note">※◎は昇格ポイント対象クラス</div>
            </div>
        </div>
        <div class="info-item">
            <div class="info-label bg_org_gray">エントリー</div>
            <div class="info-value">
                <div v-if="entryLoading">
                  <div class="text-center">
                    <div class="spinner-border spinner-border-sm" role="status"></div>
                  </div>
                  <p class="text-center mb-0">読み込み中...</p>
                </div>
                <div v-else-if="entryStart == false && data.mfj_event_main_data_url">
                  <p class="text-muted mb-0">詳しくは主催者の<a :href="data.mfj_event_main_data_url" target="_blank">公式サイト</a>からご確認ください。</p>
                </div>
                <div v-else-if="entryStart == false">
                  <p class="text-muted mb-0">受付期間外です</p>
                </div>
                <div v-else-if="entryOptions.length > 0">
                  <div class="mb-3" v-for="option in entryOptions" :key="option.id">
                    <div class="mb-2">
                      <span v-html="'▼' + option.class_name + '▼'" style="font-weight: bold;"></span>
                    </div>
                    <div v-if="option.is_matched==1" class="d-grid gap-2">
                      <button
                        class="btn btn-outline-primary btn-sm"
                        @click="goToOption(option)"
                      >所持ライセンスでエントリーできます
                      </button>
                    </div>
                    <div v-else-if="option.is_matched==0">
                      <p class="alert alert-warning p-1 alert-sm mb-1">所持しているライセンスではエントリーできません。</p>
                      <div class="d-grid gap-2">
                        <button
                          class="btn btn-outline-primary btn-sm"
                          @click="goToOption(option)"
                        >エントリー
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="data.mfj_event_main_data_url">
                  <p class="text-muted mb-0">詳しくは主催者の<a :href="data.mfj_event_main_data_url" target="_blank">公式サイト</a>からご確認ください。</p>
                </div>
                <div v-else>
                  <p class="text-muted mb-0">詳しくは主催者の公式サイトからご確認ください。</p>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, ref, watch } from 'vue'
import config from '../../../const'
import axios from 'axios'

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  user_token: {
    type: String,
    required: true,
  },
  member_license: {
    type: Array,
  },
  loadMsEventTokenObj: {
    type: Function,
    required: true,
  },
})

const expanded = ref(false)
const entryLoading = ref(false)
const entryOptions = ref([])
const entryStart = ref(true)
const entryFetched = ref(false)

const race_data_cd = computed(() => props.data.mfj_event_main_data_cd)
const race_data_seq = computed(() => props.data.mfj_event_sub_data_cd_seq)

// ページャー等で list が差し替わると同じ index の component インスタンスが
// 使い回されるため、data が変わったら開閉・取得済みのエントリー情報をリセットする
watch(() => props.data, () => {
  expanded.value = false
  entryLoading.value = false
  entryOptions.value = []
  entryStart.value = true
  entryFetched.value = false
})

const baseUrl = computed(() => {
  const env = process.env.VUE_APP_ENV
  if (env === 'production') {
    return config.SSO_SITE_URL
  } else if (['staging', 'mfj'].includes(env)) {
    return 'https://staging.ms-event.net'
  } else if (env === 'sandbox') {
    return 'https://sandbox.ms-event.net'
  } else if (env === 'development') {
    return 'https://local7.ms-event.net:8443'
  } else {
    return config.SSO_SITE_URL
  }
})

const toggleDetail = async () => {
  expanded.value = !expanded.value
  if (expanded.value && !entryFetched.value) {
    await loadEntryOptions()
  }
}

const loadEntryOptions = async () => {
  entryLoading.value = true
  entryOptions.value = []
  try {
    await fetchEntryOptions()
    entryFetched.value = true
  } catch (e) {
    // 読み込み失敗時は静かに諦め、公式サイト誘導の表示に委ねる
  } finally {
    entryLoading.value = false
  }
}

const fetchTokenFromServer = async () => {
  const result = await props.loadMsEventTokenObj()
  if (result?.status === 200 && result?.data?.body?.token) {
    return result.data.body.token
  }
  throw new Error('SSOトークン取得に失敗しました。')
}

const fetchEntryOptions = async () => {
  const params = new URLSearchParams()
  params.append('sprm[race_data_cd]', race_data_cd.value)
  params.append('sprm[race_data_seq]', race_data_seq.value)
  if (Array.isArray(props.member_license) && props.member_license.length > 0) {
    params.append('sprm[member_license]', JSON.stringify(props.member_license))
  }
  params.append('sprm[target_date]', 'now')
  const result = await axios
    .post(
      config.BASE_API_URL + '/member/mseventraceclass',
      params,
      { headers: { [config.BASE_API_USER_HEADER_KEY]: props.user_token } }
    )
    .then(async (response) => {
      return (response?.data?.body?.response) ? response?.data?.body?.response : false
    })

  entryStart.value = true
  if (result && 'entryStart' in result && result.entryStart == false) {
    entryStart.value = false
  }
  entryOptions.value = result
  if (!entryOptions.value) {
    throw new Error('オプションデータが取得できませんでした。')
  }
}

const goToOption = async (option) => {
  if (!baseUrl.value) {
    throw new Error('コンフィグが未設定です。' + '.' + config.BASE_SERVICE_URL)
  }

  try {
    const token = await fetchTokenFromServer()

    const url = new URL(baseUrl.value)
    url.pathname += config.MSEVENT_COMPANY_KEY + '/user/'
    url.searchParams.set('a', 'login.user_token_login')
    url.searchParams.set('org_token', token)
    if (typeof option === 'object' && option?.race_class_relation_id) {
      url.searchParams.set('target', option?.race_class_relation_id)
    }
    const href = url.toString()
    const w = window.open(href, '_blank')
    if (!w || w == null) {
      // ブロックされたら同一タブ遷移
      window.location.assign(href)
    }
  } catch (e) {
    // 遷移失敗時は何もしない（従来仕様を踏襲）
  }
}
</script>

<style scoped>
.event-summary-toggle {
  cursor: pointer;
}
.event-toggle-icon {
  transition: transform 0.2s ease;
  flex: 0 0 auto;
}
.event-summary-toggle[aria-expanded="true"] .event-toggle-icon {
  transform: rotate(90deg);
}
.event-summary-meta {
  /* font-size: 80%; */
}
.event-summary-meta > div {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.info-grid {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  align-items: stretch;
  width: 100%;
  border-bottom: 1px dotted #ccc;
}
@media (min-width: 576px) {
  .info-item {
    width: 50%;
  }
}
.info-label {
  flex: 0 0 7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  /* font-size: 80%; */
  font-weight: bold;
  padding: 0.5rem 0.25rem;
}
.info-label-note {
  font-size: 80%;
  font-weight: normal;
}
.info-value {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.5rem 0.5rem;
}
</style>
